import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-schedule-restaurant',
  standalone: true,
  imports: [CommonModule, CardModule, TagModule],
  templateUrl: './schedule-restaurant.component.html',
  styleUrl: './schedule-restaurant.component.scss',
})
export class ScheduleRestaurantComponent {
  today: string;
  constructor() {
    const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const currentDay = new Date().getDay(); 
    this.today = dias[currentDay];
  }
}
